import { render, staticRenderFns } from "./photo-report-create.pug?vue&type=template&id=1a15a4ef&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./photo-report-create.scss?vue&type=style&index=0&id=1a15a4ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15a4ef",
  null
  
)

export default component.exports